import { render, staticRenderFns } from "./ImageAudit.vue?vue&type=template&id=36f52c6e&scoped=true"
import script from "./ImageAudit.vue?vue&type=script&lang=js"
export * from "./ImageAudit.vue?vue&type=script&lang=js"
import style0 from "./ImageAudit.vue?vue&type=style&index=0&id=36f52c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f52c6e",
  null
  
)

export default component.exports